import loadGoogleMapsApi from 'load-google-maps-api';
import $ from 'jquery';

export default class GMaps {
  constructor(map) {
    this.$map = $(map);
    if (this.$map.length === 0) return;
    const location = {
      lat: +this.$map.attr('data-lat'),
      lng: +this.$map.attr('data-lng'),
    };
    this.points = [];
    loadGoogleMapsApi({
      key: 'AIzaSyAl03dBW3BsBpkt5ReLOfhDxShdsfh5VFw',
    })
      .then((googleMaps) => {
        this.google = googleMaps;
        this.map = this.createMap(location);
        this.points.push(this.createPoint(location));
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  createMap(location) {
    return new google.maps.Map(this.$map[0], {
      zoom: 14,
      center: location,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      animation: google.maps.Animation.BOUNCE,
    });
  }

  createPoint(location) {
    return new google.maps.Marker({
      position: location,
      map: this.map,
    });
  }
}
